/**
 * SidebarLeftIcon - Sidebar-Toggle Icon für die Titlebar
 *
 * Zeigt ein Panel-Layout mit drei horizontalen Linien auf der linken Seite.
 * Ersetzt das Lucide `PanelLeft` Icon in der Titlebar.
 *
 * @example
 * ```tsx
 * <SidebarLeftIcon />
 * <SidebarLeftIcon size={20} />
 * ```
 */
export const SidebarLeftIcon = ({ size = 16 }: { size?: number }) => {
  const aspectRatio = 16 / 17
  const height = Math.round(size * aspectRatio)

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1 1.5H14.1C14.93 1.5 15.6 2.17 15.6 3V13C15.6 13.83 14.93 14.5 14.1 14.5H2.1C1.27 14.5 0.6 13.83 0.6 13V3C0.6 2.17 1.27 1.5 2.1 1.5Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6 1.5V14.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1 8H3.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1 5H3.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1 11H3.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
